import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ title, image, description, keywords, author }) => {
  const metaData = [
    { property: "og:title", content: title ? title : "Connatix" },
    { property: "og:type", content: "website" },
    {
      property: "og:image",
      content: image ? image : "https://connatix.com/assets/share-picture.png",
    },
    { name: "description", content: description },
    { name: "keywords", content: keywords },
    { name: "author", content: author },
  ];

  return (
    <Helmet
      title={title ? title : "Connatix"}
      meta={metaData}
      link={[{ rel: "canonical", href: window.location }]}
      script={[
        {
          // Hotjar Script
          type: "text/javascript",
          src: `${process.env.PUBLIC_URL}/scripts/hotjar.js`,
        },
      ]}
    ></Helmet>
  );
};

Head.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  keywords: PropTypes.string,
  author: PropTypes.string,
};

export default Head;
